import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import LuminaireDetail from '../../components/light/LuminaireDetail';
import { editLuminaire, getLuminaire } from '../../redux/luminaire/luminaire_actions';
import { defaultRejectHandler } from '../../utils/utility';

class LuminaireEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.luminaireDetail = undefined;
    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if ((this.props.luminaire !== nextProps.luminaire) && nextProps.show) {
      this.props.getLuminaire(nextProps.luminaire.id);
    }
  }

  onSaveHandler() {
    const newLuminaire = this.luminaireDetail.getWrappedInstance().getWrappedInstance().getLuminaireData();
    this.props.editLuminaire({ ...newLuminaire, id: this.props.luminaire.id });
  }

  render() {
    const { isEditing, errorMessage, luminaire, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('edit luminaire')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <LuminaireDetail
            luminaire={luminaire}
            ref={ref => this.luminaireDetail = ref}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="lighting-luminaire-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const luminaireState = state.lighting.luminaire;
  return {
    errorMessage: luminaireState.errorMessage,
    isEditing: luminaireState.isEditing,
  };
};

const mapDispatchToProps = dispatch => ({
  editLuminaire: luminaire =>
    defaultRejectHandler(
      dispatch(
        editLuminaire(
          luminaire.id,
          luminaire.name,
          luminaire.brand_id,
          luminaire.type_id,
          luminaire.power_required,
          luminaire.description || '',
          luminaire.image,
        )
      )
    ),
  getLuminaire: (id) => defaultRejectHandler(dispatch(getLuminaire(id))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(LuminaireEditModal)
);



// WEBPACK FOOTER //
// ./src/modal/luminaire/LuminaireEditModal.js